import { Component, OnInit, Input, NgModule } from '@angular/core'
import { User } from '@model/user/user'
import { UserService } from '@service/user/user.service'

import { Title } from '@angular/platform-browser';
import { TypeService } from '@service/type.service';
import { ScrollService } from '@service/scroll.service';
import { MobileService } from '@service/mobile.service';
import { AboutBlockHeaderComponentModule } from '../about-block-header/about-block-header.component';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ProfileHeaderComponentModule } from '../profile-header/profile-header.component';
import { SharedModule } from 'src/app/shared.module';
import { StateService } from '@service/state.service';
import { BlogCardComponentModule } from '@component/generic/cards/blog-card/blog-card.component';
import { AdvertGridItemModule } from '@component/shared/advert-grid-item/advert-grid-item.component';
import { JobCardComponentModule } from '@component/generic/cards/job-card/job-card.component';
import { take } from 'rxjs';

@Component({
  selector: 'app-profile-external',
  templateUrl: './profile-external.component.html',
  styleUrls: ['./profile-external.component.scss']
})
export class ProfileExternalComponent implements OnInit {

  public loading: boolean = false

  active_tab: string = 'info';

  tabs = [
    {
      id: 'info',
      label: 'Info',
      visible: true,
    },
    {
      id: 'posts',
      label: 'Neuste Beiträge',
      visible: true,
    },
  ];

  @Input()
  set user(user: User) {
    this._user = user

    this.displayStructure = user.transformToDisplayStructure()

    const postsTab = this.tabs.find(tab => tab.id === 'posts');

    postsTab.visible = user.posts?.length > 0;

    if (postsTab.visible) {
      this.tabs = this.tabs.filter(tab => tab.id !== 'posts');

      this.tabs.unshift(postsTab);
      this.active_tab = this.tabs[0].id;
    }

    // set page title
    if (user.use_nickname) {
      this.title.setTitle(user.private_nickname + ' | Zimmerer-Treffpunkt')
    }
    else {
      this.title.setTitle((user.firstname || '') + ' ' + (user.lastname || '') + ' | Zimmerer-Treffpunkt')
    }
  }

  get user(): User {
    return this._user
  }

  private _user: User = null
  public displayStructure = null

  constructor(
    private userService: UserService,
    private title: Title,
    public typeService: TypeService,
    private scrollService: ScrollService,
    public MobileService: MobileService,
    public ActivatedRoute: ActivatedRoute,
    public StateService: StateService,
  ) {
    this.ActivatedRoute.params.pipe(take(1)).subscribe(params => {

      this.StateService.params = params

      this.loading = true
      this.userService.getUserById(params.id)
        .then((user: User) => {
          this.user = user
        })
        .finally(() => {
          this.loading = false
        })
    })

    // We keep track of the active tab via a query parameter. This allows users
    // to link to a specific tab of a profile.
    this.ActivatedRoute.queryParams.subscribe(query => {
      const query_tab = query.tab;
      const valid_tabs = this.tabs.map(tab => tab.id);

      this.active_tab = valid_tabs.includes(query_tab) ? query_tab : this.tabs[0].id;
    });
  }

  setActiveTab(tab: string) {
    const valid_tabs = this.tabs.map(tab => tab.id);

    if (valid_tabs.includes(tab)) {
      this.active_tab = tab;
    }
  }

  ngOnInit() {
    this.scrollService.scrollToTop()
  }
}

@NgModule({
  declarations: [
    ProfileExternalComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: "",
        component: ProfileExternalComponent
      },
    ]),
    AboutBlockHeaderComponentModule,
    ProfileHeaderComponentModule,
    BlogCardComponentModule,
    AdvertGridItemModule,
    JobCardComponentModule,
  ],
  exports: [
    ProfileExternalComponent,

    SharedModule,
    AboutBlockHeaderComponentModule,
    ProfileHeaderComponentModule,
  ]
})
export class ProfileExternalComponentModule { }